import { render, staticRenderFns } from "./LoginFlowStepOTP.vue?vue&type=template&id=69224695&scoped=true&"
import script from "./LoginFlowStepOTP.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepOTP.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFlowStepOTP.vue?vue&type=style&index=0&id=69224695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69224695",
  null
  
)

export default component.exports